import React from 'react';
import { CompositeView, Form, GridView, SimpleView, usePromise } from '@digital/ui';
import { updateUsuario, getUsuarioInfo, Usuario } from '../../api/usuario';
import PerfilForm from './PerfilForm';
import { getLoggedId } from '../../helpers';

const Perfil = () => {
  const userId = getLoggedId();
  const [userInfo] = usePromise(
    () => (userId ? getUsuarioInfo(userId) : Promise.resolve(undefined)),
    [userId],
    {} as Usuario,
  );

  return (
    <CompositeView>
      <SimpleView>
        <GridView noform>
          <PerfilForm selectedItem={userInfo} onUpdate={() => { }} />
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};

export default Perfil;
